import React, { useState } from "react";
import VendorRole from "../../Dashboard/components/Roles/Vendor/Vendor";
import EditVendorProfile from "../../Dashboard/components/Roles/Vendor/EditVendorProfile";

const MyAccount = () => {
  const [isProfileEditing, setIsProfileEditing] = useState(false);

  return (
    <>
      {!isProfileEditing ? (
        <VendorRole setIsProfileEditing={setIsProfileEditing} />
      ) : (
        <EditVendorProfile setIsProfileEditing={setIsProfileEditing}/>
      )}
    </>
  );
};

export default MyAccount;
